import React from 'react';

import IconSelector from '@ibibo/icon-selector';
import {defaultTheme} from '@ibibo/build-theme';

import * as S from './MySafety.styles';

const iconProps = {
  fill: defaultTheme.colors.blue.dark,
  width: '2.8rem',
  height: '2.8rem'
}

const MySafety = () => {
  return (
    <S.MySafetyBlockWrapper>
      <S.MySafetyBlockInner>
        <S.MySafetyHeadBlock>
          <S.BenefitHeader>The <span id="mySafety">My</span><span id="safety">Safety</span> Assurance</S.BenefitHeader>
          <S.BenefitSubHeader>Offer a stay with the best safety and hygiene standards to your customers. Our MySafety Assured properties promise:</S.BenefitSubHeader>
        </S.MySafetyHeadBlock>
        <S.MySafetyWrapper>
          <S.MySafetyBlock>
            <li>
              <S.IconWrapper><IconSelector iconKey="tickgreen" props={iconProps} /></S.IconWrapper>
              <S.TextWrapper><span>Hygienic Rooms</span><br />Thorough disinfection & provision of face masks & gloves</S.TextWrapper>
            </li>
            <li>
              <S.IconWrapper><IconSelector iconKey="tickgreen" props={iconProps} /></S.IconWrapper>
              <S.TextWrapper><span>Trained Staff</span><br />Strict regulation of hygiene & social distancing</S.TextWrapper>
            </li>
            <li>
              <S.IconWrapper><IconSelector iconKey="tickgreen" props={iconProps} /></S.IconWrapper>
              <S.TextWrapper><span>Sanitized Indoors</span><br />Thorough disinfection of common areas & regular temperature checks for all</S.TextWrapper>
            </li>
            <li>
              <S.IconWrapper><IconSelector iconKey="tickgreen" props={iconProps} /></S.IconWrapper>
              <S.TextWrapper><span>Safe Dining</span><br />Regular sanitization of kitchen, staff & supplies</S.TextWrapper>
            </li>
          </S.MySafetyBlock>
        </S.MySafetyWrapper>
        <S.IconWrapper><IconSelector iconKey="mysafetyseperator" /></S.IconWrapper>
      </S.MySafetyBlockInner>
    </S.MySafetyBlockWrapper>
  );
};

export default MySafety;
